<template>
<div class="container-fluid">
	<service-toolbar></service-toolbar>

	<expense-table
		v-if="$store.service.id"
		heading="Expenses"
		:heading-small="'Service #'+$store.service.job_num+', '+$store.service.job_name"
		:show-user="true"
		:show-job="false"
		:editable="true"
		:filtering-tools="true"
		:filters="expenseFilters">
	</expense-table>
</div>
</template>

<script>

import ServiceToolbar from "./ServiceToolbar"
import ExpenseTable from "@/components/super_components/ExpenseTable"

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {

	name: 'ServiceExpenses',
	components: {
		ServiceToolbar,
		ExpenseTable
	},
	mixins: [ServiceMixins],
	computed: {
		expenseFilters() {
			return [
				["service_id",this.$store.service.id]
			]
		}
	},
	created() {
		this.setServiceIfNotSet()
	}
}
</script>

<style type="text/css">

</style>